var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex align-items-center header-search" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "click-outside",
            rawName: "v-click-outside",
            value: _vm.searchFocusOut,
            expression: "searchFocusOut"
          }
        ],
        staticClass: "w-100"
      },
      [
        _c("div", { staticClass: "d-flex justify-content-between" }, [
          _c(
            "div",
            { staticClass: "position-relative w-100" },
            [
              _c("div", {
                staticClass: "header-search-icon position-absolute"
              }),
              _vm._v(" "),
              _c("b-form-input", {
                ref: "searchInput",
                staticClass: "header-search-input pl-4",
                attrs: {
                  title: _vm.$t("mit_keresel_title"),
                  placeholder: _vm.$t("mit_keresel_title"),
                  debounce: "300",
                  type: "text"
                },
                on: {
                  update: _vm.search,
                  focusin: _vm.searchFocusIn,
                  keydown: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.goToSearchPage($event)
                  }
                },
                model: {
                  value: _vm.searchInputValue,
                  callback: function($$v) {
                    _vm.searchInputValue = $$v
                  },
                  expression: "searchInputValue"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.isMobile
            ? _c("div", {
                staticClass: "close-icon cursor-pointer ml-2",
                on: {
                  click: function($event) {
                    return _vm.$emit("closeSearch")
                  }
                }
              })
            : _vm._e()
        ]),
        _vm._v(" "),
        !_vm.isMobile
          ? _c("div", [
              _vm.isSearchFocused &&
              ((_vm.articlesSearchRes && _vm.articlesSearchRes.length > 0) ||
                (_vm.productsSearchRes && _vm.productsSearchRes.length > 0))
                ? _c(
                    "div",
                    { staticClass: "autocomplete-suggestions-container" },
                    [
                      _c("a", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: "kereso_ossz_talalat",
                            expression: "'kereso_ossz_talalat'"
                          }
                        ],
                        staticClass: "all_result",
                        on: { click: _vm.goToSearchPage }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.productsSearchRes, function(product) {
                        return _c(
                          "div",
                          {
                            key: product.id,
                            staticClass: "suggestion suggestion-product"
                          },
                          [
                            _c(
                              "router-link",
                              {
                                attrs: { to: product.url },
                                nativeOn: {
                                  click: function($event) {
                                    _vm.storeClickOnProduct(product.id)
                                    _vm.resetInputAndCloseSearch()
                                  }
                                }
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-4 d-flex justify-content-center align-items-center"
                                    },
                                    [
                                      _c("img", {
                                        staticClass:
                                          "img-fluid search-result-img",
                                        attrs: {
                                          src: product.imgSrc,
                                          alt: product.title
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-8" }, [
                                    _c("div", {
                                      staticClass:
                                        "product-detail-secondary text-uppercase",
                                      domProps: {
                                        textContent: _vm._s(product.brand)
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "product-detail-primary",
                                      domProps: {
                                        textContent: _vm._s(product.title)
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass:
                                        "mt-3 product-detail-primary",
                                      domProps: {
                                        innerHTML: _vm._s(product.price)
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "product-detail-secondary",
                                      domProps: {
                                        textContent: _vm._s(
                                          product.unitPriceFormatted
                                        )
                                      }
                                    })
                                  ])
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.articlesSearchRes, function(article) {
                        return _c(
                          "div",
                          {
                            key: article.id,
                            staticClass: "suggestion suggestion-product"
                          },
                          [
                            _c(
                              "router-link",
                              {
                                attrs: { to: article.url },
                                nativeOn: {
                                  click: function($event) {
                                    _vm.storeClickOnArticle(article.id)
                                    _vm.resetInputAndCloseSearch()
                                  }
                                }
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-4 d-flex justify-content-center align-items-center"
                                    },
                                    [
                                      _c("img", {
                                        staticClass:
                                          "img-fluid search-result-img",
                                        attrs: {
                                          src: article.imgSrc,
                                          alt: article.title
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-8" }, [
                                    _c("div", {
                                      staticClass: "product-detail-primary",
                                      domProps: {
                                        textContent: _vm._s(article.title)
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "product-detail-secondary",
                                      domProps: {
                                        textContent: _vm._s(article.desc)
                                      }
                                    })
                                  ])
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                : _vm._e()
            ])
          : _c(
              "div",
              { staticClass: "mobile-search-result-container" },
              [
                _c(
                  "b-tabs",
                  { attrs: { pills: "" } },
                  [
                    _c(
                      "b-tab",
                      { attrs: { title: _vm.$t("osszes_termek"), active: "" } },
                      [
                        _vm.isSearchInProgress
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-center justify-content-center h-100 w-100"
                              },
                              [_c("loading-indicator")],
                              1
                            )
                          : _vm.productsSearchRes.length === 0
                          ? _c("div", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: "nincs_megjelenitheto_tartalom",
                                  expression: "'nincs_megjelenitheto_tartalom'"
                                }
                              ],
                              staticClass:
                                "d-flex align-items-center justify-content-center h-100 w-100"
                            })
                          : [
                              _vm._l(_vm.productsSearchRes, function(product) {
                                return _c(
                                  "div",
                                  {
                                    key: product.id,
                                    staticClass:
                                      "suggestion suggestion-product my-2"
                                  },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: { to: product.url },
                                        nativeOn: {
                                          click: function($event) {
                                            _vm.storeClickOnProduct(product.id)
                                            _vm.resetInputAndCloseSearch()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "d-flex col-12" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-4 d-flex justify-content-center align-items-center"
                                              },
                                              [
                                                _c("img", {
                                                  staticClass:
                                                    "img-fluid search-result-img",
                                                  attrs: {
                                                    src: product.imgSrc,
                                                    alt: product.title
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "col-8" },
                                              [
                                                _c("div", {
                                                  staticClass:
                                                    "product-detail-secondary text-uppercase",
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      product.brand
                                                    )
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticClass:
                                                    "product-detail-primary",
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      product.title
                                                    )
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticClass:
                                                    "mt-3 product-detail-primary",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      product.price
                                                    )
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticClass:
                                                    "product-detail-secondary",
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      product.unitPriceFormatted
                                                    )
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "go-to-all-result-mobile position-absolute py-3 w-100"
                                },
                                [
                                  _c("a", {
                                    directives: [
                                      {
                                        name: "t",
                                        rawName: "v-t",
                                        value: "kereso_ossz_talalat",
                                        expression: "'kereso_ossz_talalat'"
                                      }
                                    ],
                                    staticClass: "all_result position-relative",
                                    on: { click: _vm.goToSearchPage }
                                  })
                                ]
                              )
                            ]
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "b-tab",
                      {
                        attrs: { title: _vm.$t("menu_shop_prcikkek"), lazy: "" }
                      },
                      [
                        _vm.isSearchInProgress
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-center justify-content-center h-100 w-100"
                              },
                              [_c("loading-indicator")],
                              1
                            )
                          : _vm.articlesSearchRes.length === 0
                          ? _c("div", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: "nincs_megjelenitheto_tartalom",
                                  expression: "'nincs_megjelenitheto_tartalom'"
                                }
                              ],
                              staticClass:
                                "d-flex align-items-center justify-content-center h-100 w-100"
                            })
                          : [
                              _vm._l(_vm.articlesSearchRes, function(article) {
                                return _c(
                                  "div",
                                  {
                                    key: article.id,
                                    staticClass:
                                      "suggestion suggestion-product my-2"
                                  },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: { to: article.url },
                                        nativeOn: {
                                          click: function($event) {
                                            _vm.storeClickOnArticle(article.id)
                                            _vm.resetInputAndCloseSearch()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "d-flex col-12" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-4 d-flex justify-content-center align-items-center"
                                              },
                                              [
                                                _c("img", {
                                                  staticClass:
                                                    "img-fluid search-result-img",
                                                  attrs: {
                                                    src: article.imgSrc,
                                                    alt: article.title
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "col-8" },
                                              [
                                                _c("div", {
                                                  staticClass:
                                                    "product-detail-primary",
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      article.title
                                                    )
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticClass:
                                                    "product-detail-secondary",
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      article.desc
                                                    )
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "go-to-all-result-mobile position-absolute py-3 w-100"
                                },
                                [
                                  _c("a", {
                                    directives: [
                                      {
                                        name: "t",
                                        rawName: "v-t",
                                        value: "kereso_ossz_talalat",
                                        expression: "'kereso_ossz_talalat'"
                                      }
                                    ],
                                    staticClass: "all_result position-relative",
                                    on: { click: _vm.goToSearchPage }
                                  })
                                ]
                              )
                            ]
                      ],
                      2
                    )
                  ],
                  1
                )
              ],
              1
            )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }